import { ModelRow } from "@mcleod/core";
import { Component, DataHeader, LookupModelSelectionEvent, TableRow, Textbox } from "@mcleod/components";
import { CommonTooltips } from "@mcleod/common";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutRoutingGuideProfile } from "./autogen/AutogenLayoutRoutingGuideProfile";

const viewRoutingGuideURL = "lme/powerbroker/RoutingGuideProfile?mode=update&key=";
const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName:"routing_guide_profile",
    screenName:"Routing Guide Profile",
    navigateToUrl:viewRoutingGuideURL
}
export class RoutingGuideProfile extends AutogenLayoutRoutingGuideProfile {

    override onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }

    textboxUserIdBeforeLookupModelSearch(event) {
        event.filter.web_user_type = 'U';
    }

    textboxPayeeIdBeforeLookupModelSearch(event) {
        event.filter.status = "A";
    }

    textboxPayeeIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selectedRow = event.selection;
        const tableRow = TableRow.getContainingTableRow(event.target);
        const modelRow: ModelRow = tableRow.data;
        if (selectedRow != null) {
            modelRow.set("carrier_name", selectedRow.get("name"));
            modelRow.setValueAndLookupModelData("contact_name", selectedRow.get("contact.name"), { name: selectedRow.get("contact.name") });
            modelRow.set("contact_name", selectedRow.get("contact.name"));
            modelRow.set("contact_email", selectedRow.get("contact.email"));
            modelRow.set("contact_phone", selectedRow.get("contact.phone"));
            modelRow.set("contact_mobile_phone", selectedRow.get("contact.mobile_phone"));
        }
        else {
            modelRow.clear();
        }
        tableRow.displayComponentValues();
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxContactName.  */
    textboxContactNameBeforeLookupModelSearch(event) {
        const contactName = event.target as Textbox;
        const tableRow: TableRow = TableRow.getContainingTableRow(contactName);
        const modelRow: ModelRow = tableRow.data;
        const payeeId: string = modelRow.get("payee_id");
        if (payeeId != null) {
            event.filter.parent_row_id = payeeId;
            event.filter.parent_row_type = "P";
            event.filter.is_active = "Y";
        } else {
            event.preventDefault();
        }

        if (contactName != null)
            contactName.addLookupModelSelectionListener(this.textboxContactNameOnLookupModelSelection);
    }

    private textboxContactNameOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selectedRow = event.selection;
        if (selectedRow != null) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            const tableRowData = tableRow.data;
            tableRowData.set("contact_phone", selectedRow.get("phone"));
            tableRowData.set("contact_email", selectedRow.get("email"));
            tableRowData.set("contact_mobile_phone", selectedRow.get("mobile_phone"));
            const contactPhone = tableRow.findComponentById("textboxContactPhone") as Textbox;
            const contactEmail = tableRow.findComponentById("textboxContactEmail") as Textbox;
            const contactMobilePhone = tableRow.findComponentById("textboxContactMobilePhone") as Textbox;
            contactPhone.text = selectedRow.get("phone");
            contactEmail.text = selectedRow.get("email");
            contactMobilePhone.text = selectedRow.get("mobile_phone");
        }
    }

    tableCarriersOnRowDisplay(event) {
        const tableRow = event.getTableRow() as TableRow;
        tableRow.forEveryChildComponent((comp: Component) => {
            this.setTooltipContent(comp, tableRow.data);
        });
    }

    setTooltipContent(comp: Component, modelRow: ModelRow) {
        if (comp.id == null) return;
        switch (comp.id) {
            case "textboxPayeeId":
                return CommonTooltips.setTooltipContentLayout(comp, modelRow.get("payee_id"), "lme/powerbroker/CarrierQuickInfo", { minWidth: 128, minHeight: 140 });
        }
    }
}
